/* eslint-disable @wordpress/no-unused-vars-before-return */
import { store, getContext } from '@wordpress/interactivity';
store( 'sbtl/tabs', {
	state: {
		// Breakpoint Tracker
		isMobile: false,
		// Gate logic for whether we should collapse into accordions
		get isAccordionMode() {
			const context = getContext();
			const { state } = store( 'sbtl/tabs' );

			return context.mobileBehavior === 'accordion' && state.isMobile;
		},
		get tabBarOrientation() {
			const context = getContext();
			const { state } = store( 'sbtl/tabs' );
			// On mobile the layout always collapses to top position → horizontal
			if ( state.isMobile ) {
				return 'horizontal';
			}
			return context.tabBarPosition === 'top' ? 'horizontal' : 'vertical';
		},
		// Evaluates to true if this specific tab is the globally selected one
		get isSelected() {
			const context = getContext();
			return context.selectedId === context.tabId;
		},
		// The active tab gets tabindex "0", the rest get "-1"
		get tabIndex() {
			const { state } = store( 'sbtl/tabs' );
			return state.isSelected ? '0' : '-1';
		},
		// Layout Shifting Derived States
		get panelRole() {
			const { state } = store( 'sbtl/tabs' );
			// Mobile: Strip the role (native details). Desktop: 'tabpanel'
			return state.isAccordionMode ? undefined : 'tabpanel';
		},
		get isOpen() {
			const { state } = store( 'sbtl/tabs' );
			// Mobile: Return undefined to tell WP to LET GO of the attribute!
			// Desktop: Force open/closed based on selected tab.
			return state.isAccordionMode ? undefined : state.isSelected;
		},
		get isHidden() {
			const { state } = store( 'sbtl/tabs' );
			// Mobile: Never hide panels. Desktop: Hide inactive panels.
			return state.isAccordionMode ? false : ! state.isSelected;
		},
	},
	actions: {
		// Triggered by mouse click or Enter/Space keys (native button behavior)
		selectTab() {
			const context = getContext();
			context.selectedId = context.tabId;
		},

		// Triggered by keyboard navigation on the Tab Bar
		handleKeydown( e ) {
			const { key } = e;
			const currentTab = e.currentTarget;
			const tabList = currentTab.closest( '[role="tablist"]' );
			const { state } = store( 'sbtl/tabs' );
			const tabListOrientation = state.tabBarOrientation;

			// Dynamically set valid keys based on orientation
			const validKeys = [ 'Home', 'End' ];
			if ( tabListOrientation === 'vertical' ) {
				validKeys.push( 'ArrowUp', 'ArrowDown' );
			} else {
				validKeys.push( 'ArrowLeft', 'ArrowRight' );
			}

			// Ignore unrelated keys (let Tab, Enter, Space, or unrelated arrows do their normal thing)
			if ( ! validKeys.includes( key ) ) {
				return;
			}

			// Prevent default scrolling only if it's a valid key for THIS specific orientation
			e.preventDefault();

			const tabs = Array.from(
				tabList.querySelectorAll( '[role="tab"]' )
			);
			const currentIndex = tabs.indexOf( currentTab );
			let nextIndex = currentIndex;

			// Calculate the next index
			if ( key === 'Home' ) {
				nextIndex = 0;
			} else if ( key === 'End' ) {
				nextIndex = tabs.length - 1;
			} else if ( key === 'ArrowRight' || key === 'ArrowDown' ) {
				// Next Tab (handles both Right and Down)
				nextIndex = ( currentIndex + 1 ) % tabs.length;
			} else if ( key === 'ArrowLeft' || key === 'ArrowUp' ) {
				// Previous Tab (handles both Left and Up)
				nextIndex = ( currentIndex - 1 + tabs.length ) % tabs.length;
			}

			// Get the new tab DOM element
			const nextTab = tabs[ nextIndex ];
			const context = getContext();

			// Physically move focus
			nextTab.focus();

			// Update State (Unless admin enabled manual activation mode, in which case we only move focus and let the user decide when to activate)
			if ( ! context.manualActivation ) {
				context.selectedId = nextTab.id;
			}
		},

		// Sync native <details> toggle back to state (catches Ctrl+F, etc.)
		syncDetailsToggle( e ) {
			const context = getContext();
			if ( e.currentTarget.open ) {
				context.selectedId = context.tabId;
			}
		},
	},
	callbacks: {
		// Native Breakpoint Watcher
		initBreakpointWatcher() {
			const context = getContext();
			if ( ! context.mobileBehavior ) {
				return;
			}

			const { state } = store( 'sbtl/tabs' );

			// Set up the listener
			const query =
				context.mobileBreakpoint === 'mobile_tablet'
					? '(max-width: 960px)'
					: '(max-width: 600px)';
			const mql = window.matchMedia( query );

			// Set initial state on page load
			state.isMobile = mql.matches;

			// Listen for screen resizes and update the Interactivity API reactively
			mql.addEventListener( 'change', ( e ) => {
				state.isMobile = e.matches;
			} );
		},
	},
} );
